import type { THaulageJobsState } from '@/types/state-types'
import { HaulageJob, HaulageJobScheduleForm } from '@/models'
import HaulageJobFormCreate from '@/models/haulageJobs/HaulageJobFormCreate'

export default <THaulageJobsState>{
  haulageJobForm: new HaulageJobFormCreate(),
  haulageJobSchedule: new HaulageJobScheduleForm(),
  haulageJobDetails: new HaulageJob(),
  isHaulageFormLoading: false,
  isHaulageFormButtonLoading: false
}
